module.exports = __webpack_public_path__ + "img/costa_rica.8820d63c.svg";